export const invoiceColumnHeaders = {
    invoice_no: "Invoice No.",
    invoice_reference_no:"Invoice Reference No.",
    delivery_reference_no: "Delivery Reference No",
    order_reference_no: "Order Reference No",
    invoice_date: "Invoice Date",
    invoice_amount: "Invoice Amount",
    invoice_qunatity: "Invoice Quantity",
    status: "Status",
    actions : "Create E-way Bill"
}

export const statusHistory = {
    main_title : "History Status",
    status : "Status",
    updated_on : "Updated On",
    vendor_name : "Vendor Name",
    remarks : "Remarks",
    vehicle_no : "Vehicle Number",
    driver_name : "Driver Name",
    driver_no : "Driver Number",
    created_on : "Created On",
    accepted_on : "Accepted On"
}